module.exports = __webpack_public_path__ + "img/general-order-background.eb3c1e4f.png";